import React, { forwardRef, MouseEventHandler } from 'react';

import { useHighlightPulse } from '../../hooks/useHighlightPulse';

import { $Card } from './Card.styles';

export interface CardProps {
  withoutMarginTop?: boolean;
  withoutMarginBottom?: boolean;
  withoutPaddingBottom?: boolean;
  withoutPaddingTop?: boolean;
  withBorder?: boolean;
  elevation?: number;
  minimal?: boolean;
  isOpen?: boolean;
  colored?: boolean;
  dataTestId?: string;
  title?: string;
  isVerticalyFluid?: boolean;
  isFluid?: boolean;
  isHighlighted?: boolean;
  highlightWatchedValue?: string | number;
  className?: string;
  onClick?: MouseEventHandler;
  shouldRenderOnlyChildren?: boolean;
}

const Card = forwardRef<HTMLDivElement, React.PropsWithChildren<CardProps>>(
  (
    {
      withoutMarginTop = false,
      withoutMarginBottom = false,
      withoutPaddingBottom = false,
      withoutPaddingTop = false,
      withBorder,
      elevation = 1,
      minimal = false,
      colored = false,
      isOpen = true,
      isVerticalyFluid = false,
      isHighlighted = false,
      highlightWatchedValue,
      dataTestId,
      title,
      children,
      className,
      onClick,
      isFluid = false,
      shouldRenderOnlyChildren = false,
    },
    ref,
  ) => {
    const defaultWithBorder = true;
    const isHighlightPulseRunning = useHighlightPulse({
      isHighlighted,
      highlightWatchedValue,
    });

    if (shouldRenderOnlyChildren) {
      return <>{children}</>;
    }

    return (
      <$Card
        ref={ref}
        $withoutMarginTop={withoutMarginTop}
        $withoutPaddingBottom={withoutPaddingBottom}
        $withoutPaddingTop={withoutPaddingTop}
        $isVerticalyFluid={isVerticalyFluid}
        $isOpen={isOpen}
        data-testid={dataTestId}
        title={title}
        $withoutMarginBottom={withoutMarginBottom}
        $withBorder={withBorder ?? defaultWithBorder}
        elevation={elevation}
        $minimal={minimal}
        $colored={colored}
        className={className} // styled components
        onClick={onClick}
        $isFluid={isFluid}
        $isHighlighted={isHighlightPulseRunning}
        $isNewUi
      >
        {children}
      </$Card>
    );
  },
);

export default Card;
